<template>
   <section id="about" class="about">
      <div class="container" data-aos="fade-up">
        <div class="">
          <h2>درباره ما</h2>
          
          <div class="reset"  v-html="contentByCategoryRef.des" >
          </div>

        </div>
      </div>
    </section>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
  },
  computed: {
    ...mapGetters({
      contentByCategoryRef: "controlPanelX/contentByCategoryRef",
    }),
  },
  data() {
    return {
    };
  },
  
  methods: {
    async getContentCategoryByRef() {
      await this.$store.dispatch(
        "controlPanelX/getContentByCategoryRef",
        1
      );
    },   
  },
  created() {
    this.getContentCategoryByRef();
  },
  mounted() {},
};
</script>

<style>

</style>